import { ExternalLink } from "@octopusdeploy/design-system-components";
import type { CommitDetail } from "@octopusdeploy/octopus-server-client";
import type { DataBaseComponentState } from "~/components/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent";
import styles from "./style.module.less";
interface CommitDetailsProps {
    data: CommitDetail[];
}
export default class CommitDetails extends DataBaseComponent<CommitDetailsProps, DataBaseComponentState> {
    constructor(props: CommitDetailsProps) {
        super(props);
        this.state = {};
    }
    resolveLink = (commitDetail: CommitDetail): JSX.Element => {
        const shortCommitSha = commitDetail.Id.substring(0, 7);
        return (<div className={styles.commitCommentContainer} key={commitDetail.Id}>
                {commitDetail.LinkUrl ? (<div className={styles.commitLink}>
                        <ExternalLink href={commitDetail.LinkUrl}>{shortCommitSha}</ExternalLink>
                    </div>) : (<div className={styles.commitLink}>{shortCommitSha}</div>)}
                <div className={styles.commitComment}>{commitDetail.Comment}</div>
            </div>);
    };
    render() {
        return this.props.data.map((commitDetail) => this.resolveLink(commitDetail));
    }
    static displayName = "CommitDetails";
}
